import HomeMessagesBoard from './HomeMessagesBoard/HomeMessagesBoard'

interface HomeMessagesProps {
  hidden?: boolean
}

// The board is only fetched when the home shows it: its hooks run in HomeMessagesBoard, mounted after this guard.
const HomeMessages = ({ hidden = false }: HomeMessagesProps) => {
  if (hidden) return null

  return <HomeMessagesBoard />
}

export default HomeMessages
